import Vue from 'vue'

import { guestStore } from '@/store/gql/query'
import { $themeConfig } from '@themeConfig'

const { GET_GUEST_BY_PHONE } = guestStore()

const checkDisplayName = om => {
    // Проверяем что displayName существует, не пустой и содержит что-то кроме запятых и пробелов
    return (
        om &&
        om.displayName &&
        om.displayName.replace(',', '').trim().length > 0
    )
}

export default {
    fetchGuestByPhone(ctx, { phone }) {
        return new Promise((resolve, reject) => {
            Vue.axios
                .post(`${$themeConfig.app.gqlUrl}?refresh=true`, {
                    query: GET_GUEST_BY_PHONE,
                    variables: {
                        phone: `${phone}`,
                    },
                })
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    addMessage({ state, commit }, message) {
        const objectMessage = JSON.parse(message)

        if (objectMessage.name === 'userstate') {
            commit('SET_USER_STATE', objectMessage.state)
            this.dispatch('sessions/setStatus', objectMessage.state)
        }

        if (objectMessage.name === 'onclose') {
            // Проверяем текущее состояние звонка перед очисткой
            const currentCall = state.call

            // Очищаем состояние только если:
            // 1. Нет текущего звонка
            // 2. Или текущий звонок завершен
            // 3. Или текущий звонок соответствует закрываемому
            if (
                !currentCall ||
                currentCall.state === 'completed' ||
                (objectMessage.id && currentCall.id === objectMessage.id)
            ) {
                // Закрываем модалку сразу
                commit('SET_GUEST_MODAL', false)

                // Даем время на закрытие модалки перед очисткой состояния
                setTimeout(() => {
                    commit('SET_CALL', null)
                    commit('SET_GUEST', null)
                    commit('CLEAR_NAUMEN_STATE')
                }, 300)
            }
        }

        if (objectMessage.name === 'newcall') {
            // Проверяем displayName до очистки состояния
            if (checkDisplayName(objectMessage)) {
                commit('CLEAR_NAUMEN_STATE')
                commit('SET_CALL', objectMessage)
                commit('SET_LAST_CALL', objectMessage)
            } else {
                console.warn(
                    'Ignored newcall due to invalid displayName:',
                    objectMessage.displayName
                )
            }
        }

        if (objectMessage.name === 'callstatus') {
            if (checkDisplayName(objectMessage)) {
                commit('SET_CALL', objectMessage)
                commit('SET_LAST_CALL', objectMessage)
            }
        }

        // Обработка состояний звонка
        if (
            objectMessage.state === 'speaking' ||
            objectMessage.state === 'ringing'
        ) {
            this.dispatch('sessions/setChannel', 'calling')
        } else if (objectMessage.state === 'completed') {
            // Если звонок завершен, закрываем модалку и очищаем состояние
            commit('SET_GUEST_MODAL', false)
            setTimeout(() => {
                commit('SET_CALL', null)
                commit('SET_GUEST', null)
                commit('CLEAR_NAUMEN_STATE')
            }, 300)
        }
    },
}
